import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import PropTypes from 'prop-types';
import cn from 'classnames';

function FormRichText({
  onChange,
  onSetFieldValue,
  name,
  value,
  label,
  required,
  containerClassName,
}) {
  const [content, setContent] = React.useState('');

  const handleChange = (_, editor) => {
    const data = editor.getData();
    if (typeof onChange === 'function') {
      onChange((state) => ({
        ...state,
        [name]: data,
      }));
    }
    if (typeof onSetFieldValue === 'function') {
      onSetFieldValue(name, data);
    }
  };

  const onInit = (editor) => {
    const toolbarContainer = document.querySelector('#toolbar-container');
    toolbarContainer.appendChild(editor.ui.view.toolbar.element);
    window.editor = editor;
  };

  useEffect(() => {
    if (isEmpty(value) || value !== '') {
      setContent(value);
    }
  }, [value]);

  return (
    <div className={cn(containerClassName)}>
      {label && (
        <div className="block text-xs font-semibold text-neutral-700">
          <span>{label}</span>
          {required && <span className="ml-1 text-danger-600">*</span>}
        </div>
      )}
      <div id="toolbar-container" />
      <div className="flex-1">
        <CKEditor
          data={content}
          onReady={onInit}
          editor={DecoupledEditor}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

FormRichText.defaultProps = {
  onChange: false,
  onSetFieldValue: false,
  value: '',
  label: '',
  required: false,
  containerClassName: '',
};

FormRichText.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  onSetFieldValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  value: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  containerClassName: PropTypes.string,
};

export default FormRichText;
